<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<crucible-dialog
  [dialogTitle]="(data.citeAction?.id ? 'Edit CITE Action' : 'New CITE Action') + (data.citeAction?.isTemplate ? ' Template' : '')"
  [submitDisabled]="!errorFree()"
  [guardUnsavedWork]="true"
  (cancel)="handleEditComplete(false)"
  (submit)="handleEditComplete(true)"
>
  @if (data && data.citeAction) {
  <div crucibleDialogContent>
    @if (!data.citeAction.isTemplate) {
    <div class="add-margin">
      <div>
        <mat-form-field class="full-width">
          <mat-label>Move</mat-label>
          <mat-select placeholder="Move" [(ngModel)]="data.citeAction.moveNumber">
            @if (!data.citeAction.id && moveList.length > 1) {
            <mat-option [value]="-1">All Moves</mat-option>
            }
            @for (move of moveList; track move) {
            <mat-option [value]="move.moveNumber">
              {{ move.moveNumber }} - {{ move.description }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    }
    @if (!data.citeAction.isTemplate) {
    <div class="add-margin">
      <div>
        <mat-form-field class="full-width">
          <mat-label>Team</mat-label>
          <mat-select placeholder="Team" [(ngModel)]="data.citeAction.teamId">
            @if (!data.citeAction.id && data.teamList.length > 1) {
            <mat-option value="">All Teams</mat-option>
            }
            @for (team of data.teamList; track team) {
            <mat-option [value]="team.id">
              {{ team.name }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    }
    @if (!data.citeAction.isTemplate) {
    <div class="add-margin">
      <div>
        <mat-form-field class="full-width">
          <mat-label>Display Order</mat-label>
          <input matInput [(ngModel)]="data.citeAction.actionNumber" />
        </mat-form-field>
      </div>
    </div>
    }
    <div class="add-margin">
      <div>
        <mat-form-field class="full-width">
          <mat-label>Description of the Action</mat-label>
          <input matInput [(ngModel)]="data.citeAction.description" />
        </mat-form-field>
      </div>
    </div>
  </div>
  }
</crucible-dialog>
